import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_desk_workspace: FaireThemeEntity = {
  token: "discovery_theme_desk-workspace",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Desk & Workspace Finds",
  description: "Stylish productivity boosters for the desk",
  bgColor: "#EDE0F5",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
